// 域名获取
    function convertDomain (currDomain) {
        var localDomain = window.location.host
        var name = localDomain.split('.', 2)[0]
        var arr = name.split('-', 2)
        return arr.length > 1 ? arr[0] + '-' + currDomain : currDomain
    }
  
// 进行配置
  let address = 'https://' + convertDomain('')
  export {address}